
import FileSaver from 'file-saver';
import get from 'lodash/get';

import { getValueAsCsvRow } from './measureUtils';

const handleExportCoordCsv = (measure) => {
    let content = [
        'x;y;z',
        ...measure.values.coords.map(item => {
            return `${item.x};${item.y};${item.z}`;
        })
    ].join('\r\n');

    let blob = new Blob(['\ufeff', content], {type: 'text/plain;charset=utf-8;'});
    FileSaver.saveAs(blob, 'points.csv');
}

const handleExportMeasureJson = (measure) => {
    let content = {
        list: measure.measureList.map(item => {
            return {
                type: item.type,
                values: item.values
            }
        })
    };
    content = JSON.stringify(content);

    let blob = new Blob(['\ufeff', content], {type: 'application/json;charset=utf-8;'});
    FileSaver.saveAs(blob, 'mereni.json');
}

const handleExportValuesCsv = (measure) => {
    let content = [
        'nazev;hodnota;jednotka',
    ];

    for (let name in measure.values) {
        if (name !== 'coords') {
            content.push(getValueAsCsvRow(name, measure.values[name]));
        }
    }

    content = content.join('\r\n');

    let blob = new Blob(['\ufeff', content], {type: 'text/plain;charset=utf-8;'});
    FileSaver.saveAs(blob, 'values.csv');
}

export const getExportItems = (measure, options) => {
    let items = [];
    if (measure) {
        if (options.exportCoordCsv) {
            items.push({
                key: 'coordsCsv',
                text: 'Seznam souřadnic do CSV',
                disabled: (get(measure, 'values.coords.length', 0) === 0),
                onClick: () => handleExportCoordCsv(measure)
            });
        }

        if (options.exportValuesCsv) {
            items.push({
                key: 'valuesCsv',
                disabled: (Object.keys(measure.values || {}).length <= 1),
                text: 'Seznam naměřených hodnot do CSV',
                onClick: () => handleExportValuesCsv(measure)
            });
        }

        if (options.exportMeasureJson) {
            items.push({
                key: 'measureJson',
                text: 'Seznam měření do JSON',
                disabled: (measure.measureList.length === 0),
                onClick: () => handleExportMeasureJson(measure)
            });
        }
    }
    return items;
}
